import React from 'react';
import { connect } from 'react-redux';
import { SignUpView } from '../../components';

import './styles.scss';
import GrantLocationTitle from '../../components/Grants/locationTitle';

const propTypes    = {};
const defaultProps = {};

const components = {
  SignUpView,
};

class FixedTemplateView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      queryResults: {},
    };
    this.renderComponent = this.renderComponent.bind(this);
  }

  componentDidMount() {

  }

  componentDidUpdate() {

  }

  renderComponent(template) {
    const ComponentName = components[template];
    return <ComponentName />;
  }

  render() {
    const {template} = this.props;

    return (
      <div className="container-fluid content grants-page bg-fff-65">
        <div className="row">
          <div className="col-sm-12 pr-35 pl-35">
            {this.renderComponent(template)}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

FixedTemplateView.propTypes = propTypes;
FixedTemplateView.defaultProps = defaultProps;

export default connect(mapStateToProps)(FixedTemplateView);
